import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=00da13fa&scoped=true&"
import script from "./ContractDetail.vue?vue&type=script&lang=js&"
export * from "./ContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=00da13fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da13fa",
  null
  
)

export default component.exports